module.exports = __webpack_public_path__ + "img/gumroad.80327a93.png";